import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Alert,
  Container,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  subscriptionExpired,
  trialEnded,
} from '../../helpers/App';

const AdminPaymentInfo = ({ client }) => {
  const intl = useIntl();

  if (client.payment_disabled) {
    return null;
  }

  return (
    <div className="main-content">
      <Container fluid>
        <header className="page-header">
          <h2 className="page-title">
            {intl.formatMessage({ defaultMessage: 'Manage Subscription' })}
          </h2>
        </header>
        <div className="content-wrapper">
          {(trialEnded(client) && !client.is_subscribed) && (
            <Alert color="danger">
              {intl.formatMessage(
                { defaultMessage: 'Your free trial has ended. Contact your account administrator or get in touch at <a>help@stockpress.co</a>.' },
                {
                  a: email => <a href="mailto:help@stockpress.co">{email}</a>,
                },
              )}
            </Alert>
          )}
          {subscriptionExpired(client) && (
            <Alert color="danger">
              {intl.formatMessage(
                { defaultMessage: 'Your subscription expired. Contact your account administrator or get in touch at <a>help@stockpress.co</a>.' },
                {
                  a: email => <a href="mailto:help@stockpress.co">{email}</a>,
                },
              )}
            </Alert>
          )}
        </div>
      </Container>
    </div>
  );
};

const mapStateToProps = state => ({
  client: state.Auth.profile?.client,
});

AdminPaymentInfo.propTypes = {
  client: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(AdminPaymentInfo);
